<template>
  <div class="rider-info">
    <el-card class="rider-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">骑手个人信息</div>
          <div class="card-actions">
            <el-button
              class="btn-secondary"
              size="small"
              @click="downloadTemplate"
            >
              下载模板
            </el-button>
            <el-button
              class="btn-secondary"
              size="small"
              @click="exportToExcel"
            >
              导出Excel
            </el-button>
            <el-upload
              :show-file-list="false"
              :before-upload="handleImport"
              accept=".csv,.xls,.xlsx"
            >
              <el-button class="btn-secondary" size="small">导入Excel</el-button>
            </el-upload>
            <el-button
              class="btn-primary"
              icon="el-icon-plus"
              @click="openCreateDialog"
            >
              新增骑手
            </el-button>
          </div>
        </div>
      </template>
      <el-table
        :data="riders"
        size="small"
        style="width:100%"
        stripe
        class="rider-table"
      >
        <el-table-column prop="name" label="姓名" min-width="140" />
        <el-table-column prop="phone" label="联系方式" min-width="160" />
        <el-table-column prop="region1" label="区域1" min-width="120" show-overflow-tooltip />
        <el-table-column prop="region2" label="区域2" min-width="120" show-overflow-tooltip />
        <el-table-column prop="health_certificate_expiry" label="健康证到期时间" min-width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.health_certificate_expiry) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="140">
          <template slot-scope="scope">
            <span
              class="status-tag"
              :class="getStatusClass(scope.row.status)"
            >
              {{ getStatusText(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="small"
              class="btn-secondary"
              @click="openEditDialog(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              class="btn-secondary danger"
              @click="deleteRider(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="currentRider.id ? '编辑骑手' : '新增骑手'" :visible.sync="dialogVisible" width="480px">
      <el-form :model="currentRider" label-width="90px" class="rider-form">
        <el-form-item label="姓名">
          <el-input v-model="currentRider.name" />
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="currentRider.phone" />
        </el-form-item>
        <el-form-item label="区域1">
          <el-select v-model="currentRider.region1" placeholder="请选择区域1" style="width: 100%;" filterable allow-create>
            <el-option
              v-for="r in deliveryRegionOptions"
              :key="r"
              :label="r"
              :value="r"
            />
          </el-select>
          <div class="rider-region-tip">与小程序「配送区域」一致；可再填街道关键词，英文逗号分隔，如：温岭太平,太平街道</div>
        </el-form-item>
        <el-form-item label="区域2">
          <el-select v-model="currentRider.region2" placeholder="请选择区域2" style="width: 100%;" filterable allow-create>
            <el-option
              v-for="r in deliveryRegionOptions"
              :key="r"
              :label="r"
              :value="r"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="健康证到期">
          <el-date-picker
            v-model="currentRider.health_certificate_expiry"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="currentRider.status" placeholder="请选择">
            <el-option label="空闲" value="idle" />
            <el-option label="配送中" value="delivering" />
            <el-option label="离线" value="offline" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRider">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { getAdminAuthHeader } from '../utils/auth'

function riderAuthCfg (extra = {}) {
  return {
    ...extra,
    headers: { ...(extra.headers || {}), ...getAdminAuthHeader() }
  }
}

export default {
  name: 'RiderInfo',
  data () {
    return {
      riders: [],
      dialogVisible: false,
      deliveryRegionOptions: [
        '温岭太平',
        '温岭城东',
        '温岭城西',
        '温岭城北',
        '温岭横峰',
        '温岭城南',
        '温岭泽国',
        '温岭温西'
      ],
      currentRider: {
        id: '',
        name: '',
        phone: '',
        region1: '',
        region2: '',
        health_certificate_expiry: '',
        status: 'idle'
      }
    }
  },
  mounted () {
    this.fetchRiders()
  },
  methods: {
    async fetchRiders () {
      try {
        const resp = await axios.get('/api/riders', riderAuthCfg())
        if (resp.data && resp.data.code === 200) {
          this.riders = resp.data.data || []
          return
        }
      } catch (e) {
        // 接口不可用时使用测试数据，避免页面空白
        this.riders = [
          {
            id: 'r1',
            name: '测试骑手A',
            phone: '13800000001',
            health_certificate_expiry: '2026-12-31',
            status: 'idle'
          },
          {
            id: 'r2',
            name: '测试骑手B',
            phone: '13800000002',
            health_certificate_expiry: '2026-10-31',
            status: 'delivering'
          }
        ]
        this.$message.warning('骑手接口不可用，已加载测试数据')
      }
    },
    openCreateDialog () {
      this.currentRider = {
        id: '',
        name: '',
        phone: '',
        region1: '',
        region2: '',
        health_certificate_expiry: '',
        status: 'idle'
      }
      this.dialogVisible = true
    },
    openEditDialog (row) {
      this.currentRider = {
        id: row.id,
        name: row.name,
        phone: row.phone,
        region1: row.region1 || '',
        region2: row.region2 || '',
        health_certificate_expiry: row.health_certificate_expiry,
        status: row.status
      }
      this.dialogVisible = true
    },
    async deleteRider (row) {
      try {
        await this.$confirm(`确定要删除骑手「${row.name}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // 目前只在前端移除，避免影响现有后端逻辑
        this.riders = this.riders.filter(r => r.id !== row.id)
        this.$message.success('骑手已删除')
      } catch (e) {
        // 用户取消或关闭对话框
      }
    },
    async saveRider () {
      try {
        const payload = {
          name: this.currentRider.name,
          phone: this.currentRider.phone,
          region1: this.currentRider.region1 || '',
          region2: this.currentRider.region2 || '',
          health_certificate_expiry: this.currentRider.health_certificate_expiry,
          status: this.currentRider.status
        }
        if (this.currentRider.id) {
          await axios.put(`/api/riders/${this.currentRider.id}`, payload, riderAuthCfg())
        } else {
          await axios.post('/api/riders', payload, riderAuthCfg())
        }
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.fetchRiders()
      } catch (e) {
        this.$message.error('保存失败')
      }
    },
    getStatusText (status) {
      switch (status) {
        case 'idle': return '空闲'
        case 'delivering': return '配送中'
        case 'offline': return '离线'
        default: return status || '未知'
      }
    },
    getStatusClass (status) {
      switch (status) {
        case 'idle': return 'status-idle'
        case 'delivering': return 'status-delivering'
        case 'offline': return 'status-offline'
        default: return 'status-default'
      }
    },
    exportToExcel () {
      if (!this.riders.length) {
        this.$message.info('当前没有可导出的骑手数据')
        return
      }
      const header = ['姓名', '联系方式', '健康证到期时间', '状态']
      const rows = this.riders.map(r => [
        r.name || '',
        r.phone || '',
        this.formatDate(r.health_certificate_expiry) || '',
        this.getStatusText(r.status) || ''
      ])
      const csv = [header.join(','), ...rows.map(r => r.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = '骑手信息_导出.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      this.$message.success('导出成功，请在浏览器下载中查看。')
    },
    downloadTemplate () {
      const header = ['姓名', '联系方式', '健康证到期时间(YYYY-MM-DD)', '状态(idle/delivering/offline)']
      const csv = header.join(',') + '\n'
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = '骑手信息_模板.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      this.$message.success('模板已下载。')
    },
    handleImport (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const text = e.target.result
        const lines = String(text).split(/\r?\n/).filter(l => l.trim())
        if (lines.length <= 1) {
          this.$message.error('文件没有数据')
          return
        }
        const imported = lines.slice(1).map((line, idx) => {
          const cols = line.split(',').map(c => c.replace(/^"|"$/g, '').replace(/""/g, '"'))
          return {
            id: `imp_${Date.now()}_${idx}`,
            name: cols[0] || '',
            phone: cols[1] || '',
            health_certificate_expiry: cols[2] || '',
            status: cols[3] || 'idle'
          }
        })
        this.riders = imported
        this.$message.success('导入成功')
      }
      reader.readAsText(file, 'utf-8')
      return false
    },
    formatDate (val) {
      if (!val) return ''
      const d = new Date(val)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  }
}
</script>

<style scoped>
.rider-region-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 6px;
}

.rider-info {
  padding: 24px;
  background: #f5f7fa;
}

.rider-card {
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.06);
  border: none;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.rider-table ::v-deep(.el-table__header-wrapper th) {
  background: #f7f8fa;
  color: #1d2129;
  font-weight: 600;
  padding-top: 14px;
  padding-bottom: 14px;
}

.rider-table ::v-deep(.el-table__header-wrapper thead tr) {
  background: #f7f8fa;
}

.rider-table ::v-deep(.el-table__body-wrapper td) {
  padding-top: 16px;
  padding-bottom: 16px;
}

.rider-table ::v-deep(.el-table__body-wrapper tr:nth-child(2n)) {
  background: #fafafa;
}

.rider-table ::v-deep(.el-table__body-wrapper tr:hover > td) {
  background-color: #f2f3f5 !important;
  transition: background-color 0.2s ease;
}

.rider-table ::v-deep(.el-table__inner-wrapper) {
  border-bottom: 1px solid #e5e6eb;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.status-idle {
  background: #E8F3FF;
  color: #165DFF;
}

.status-delivering {
  background: #FFF7E8;
  color: #FF7D00;
}

.status-offline {
  background: #F5F5F5;
  color: #86909C;
}

.status-default {
  background: #F0F5FF;
  color: #165DFF;
}

.rider-form .el-form-item__content .el-input,
.rider-form .el-form-item__content .el-select,
.rider-form .el-form-item__content .el-date-editor {
  width: 100%;
}
</style>

